import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { useSwiper } from 'swiper/react';
import { store } from '../state/state';
import Button from './Button';
import ButtonLink from './ButtonLink';
const TripBuilderFooter = () => {
    const swiper = useSwiper();
    const globalState = useContext(store);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { state } = globalState;
    const params = {
        answers: '',
        ...state.answers
    };
    return (_jsxs("footer", { className: "flex items-center justify-between corridor", children: [_jsx("div", { className: "flex items-center swiper-pagination space-x-2" }), _jsxs("div", { className: "flex items-center space-x-6 !pb-[2px]", children: [_jsx(Button, { onClick: () => swiper.slidePrev(), variant: "no-underline", isDisabled: swiper.isBeginning, children: "Back" }), swiper.isEnd ? (_jsx(ButtonLink, { href: `${window.mainSiteData.tripBuilderResults}?${new URLSearchParams(params).toString()}`, children: "View your results" })) : (_jsx(Button, { onClick: () => swiper.slideNext(), isDisabled: !state.answers.hasOwnProperty('q1'), children: "Next" }))] })] }));
};
export default TripBuilderFooter;
